import { createFileRoute } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, RouteName, TextKey } from '@mews-commander/enums';
import {
    fetchNewReservationScreenDependencies,
    NewReservationContainer,
    newReservationScreenUrlParamsSchema,
} from '@mews-commander/modules/src/modules/newReservation';
import { MewsTeam, RouteType } from '@mews/enums';
import { useUUID } from '@mews/framework';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Reservation/Create')({
    validateSearch: newReservationScreenUrlParamsSchema,
    component: Component,
    loader: async ({ context: { dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED } }) => {
        await dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED(fetchNewReservationScreenDependencies());
    },
    staticData: {
        title: TextKey.NewReservation,
        routeName: RouteName.ReservationCreate,
        owner: MewsTeam.Reservations,
        type: RouteType.Frontend,
    },
});

function Component() {
    const id = useUUID();
    return (
        <NewReservationContainer
            scope={id}
            guideLink={createGuideLink(ArticlePath.CreateReservation)}
            searchParams={Route.useSearch()}
        />
    );
}
